// APIs
import OnboardingApi from '@/api/onboarding/onboarding-api';
import UserApi from '@/api/user/user-api';

// Models
import OnboardingChecklistItemModel from '@/model/onboarding-checklist-item-model';

// Utils
import { isOnCustomerFormExternalAccess } from '@/utils/external-access-route';

const ADMIN_ACCESS_PROFILE_ID = 1;

const mixinOnboardingChecklist = {
  data() {
    return {
      checklistItems: [],
      checklistProgress: { completed: 0, total: 0 },
      checklistLoading: false,
      checklistError: false,
      isAdminUser: false,
    };
  },
  computed: {
    hasPendingItems() {
      return this.checklistItems.some(item => !item.isCompleted);
    },
    shouldShowChecklist() {
      return this.isAdminUser && this.hasPendingItems;
    },
  },
  methods: {
    async loadAdminStatus() {
      const user = this.appData?.currentUser || this.user;

      if (!user?.id || isOnCustomerFormExternalAccess()) return;

      try {
        const api = new UserApi(user);
        const response = await api.findById(user.id);
        const accessProfiles = response.data?.accessProfile || [];

        this.isAdminUser = accessProfiles.some(profile => Number(profile.id) === ADMIN_ACCESS_PROFILE_ID);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[loadAdminStatus] erro:', error?.response?.status, error?.message, error);
      }
    },

    async loadChecklistStatus() {
      if (!this.isAdminUser) return;

      this.checklistLoading = true;
      this.checklistError = false;

      const user = this.appData?.currentUser || this.user;

      try {
        const api = new OnboardingApi(user);
        const response = await api.getStatus();

        this.checklistItems = response.data.items.map(item => new OnboardingChecklistItemModel(item));
        this.checklistProgress = response.data.progress;
      } catch { // eslint-disable-next-line no-empty
        this.checklistError = true;
        this.checklistItems = [];
        this.checklistProgress = { completed: 0, total: 0 };
      } finally {
        this.checklistLoading = false;
      }
    },
  },
};

export default mixinOnboardingChecklist;
